// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._n6347jlr [data-ds--text-field--container]{border-color:var(--ds-border-bold,#758195)}._18u0u2gc{margin-left:var(--ds-space-100,8px)}\n._19pkidpf{margin-top:0}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._otyridpf{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
